import { __awaiter, __generator } from "tslib";
import { fetchCapabilities } from '@office-start/capabilities-service';
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
export function getCapabilitiesAndContext() {
    return __awaiter(this, void 0, void 0, function () {
        var context, correlationId, defaultLinkTarget, getAccessToken, inMockMode, jwtAuthEnabled, officeHomeApiRoot, router, preferredCulture, sessionId, uiContext, workload, capabilities;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    context = _a.sent();
                    correlationId = context.correlationId, defaultLinkTarget = context.defaultLinkTarget, getAccessToken = context.getAccessToken, inMockMode = context.inMockMode, jwtAuthEnabled = context.jwtAuthEnabled, officeHomeApiRoot = context.officeHomeApiRoot, router = context.router, preferredCulture = context.preferredCulture, sessionId = context.sessionId, uiContext = context.uiContext, workload = context.workload;
                    return [4 /*yield*/, fetchCapabilities()];
                case 2:
                    capabilities = _a.sent();
                    if (!capabilities) {
                        throw new Error('Capabilities not available');
                    }
                    return [2 /*return*/, {
                            capabilities: capabilities,
                            context: context,
                            correlationId: correlationId,
                            defaultLinkTarget: defaultLinkTarget,
                            getAccessToken: getAccessToken,
                            inMockMode: inMockMode,
                            jwtAuthEnabled: jwtAuthEnabled,
                            officeHomeApiRoot: officeHomeApiRoot,
                            preferredCulture: preferredCulture,
                            router: router,
                            sessionId: sessionId,
                            uiContext: uiContext,
                            workload: workload,
                        }];
            }
        });
    });
}
//# sourceMappingURL=getCapabilitiesAndContext.js.map